import styled from 'styled-components';
import theme from 'themes';

export const NavWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  .icon {
    margin-right: 12px;
  }
`;
export const List = styled.ul`
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const NavItem = styled.li<{ active?: boolean; isTabEnabled?: boolean }>`
  flex: 1;
  padding: 1rem;
  cursor: pointer;
  text-align: center;
  background-color: ${({ active, theme }) =>
    active ? theme.colors.mediumBlue4 : `${theme.colors.mediumBlue4}50`};
  border-bottom: ${({ active, theme }) =>
    active ? `0.125rem solid ${theme.colors.primaryBlue5}` : 'none'};
  cursor: ${({ isTabEnabled }) => (isTabEnabled ? 'pointer' : 'not-allowed')};
  span {
    opacity: ${({ isTabEnabled }) => (isTabEnabled ? 1 : 0.4)};
  }
`;

export const FlyoutNavItem = styled.li<{ active?: boolean; isTabEnabled?: boolean }>`
  flex: 1;
  padding: 0.75rem;
  cursor: pointer;
  text-align: center;
  background-color: ${({ active, theme }) =>
    active ? theme.colors.white : theme.colors.lightGrey1};
  border: 0.125rem solid ${theme.colors.lightGrey3};
  border-bottom: 0px solid ${theme.colors.lightGrey3};
  border-color: ${({ active, theme }) => (active ? `${theme.colors.primaryBlue5}` : `transparent`)};
  border-left: none;
  border-right: none;
  position: relative;
  box-shadow: ${({ active }) => (active ? 'none' : '0px -1px 1px 0px #0000000f inset')};
  cursor: ${({ isTabEnabled }) => (isTabEnabled ? 'pointer' : 'not-allowed')};
  border-radius-top-left: 1px;
  border-radius-top-right: 1px;
  span {
    opacity: ${({ isTabEnabled }) => (isTabEnabled ? 1 : 0.4)};
  }

  .divider {
    position: absolute;
    height: 100%;
    width: 1px;
    background: ${theme.colors.lightGrey3};
    right: 0;
    top: 0;
    box-shadow: 1px 0px 1px 0px #0000000d;
  }
  display: ${({ isTabEnabled }) => (isTabEnabled ? 'block' : 'none')};
`;
